/* eslint-disable no-multi-spaces */
import React, { useContext, useState } from 'react'
import Box from '@material-ui/core/Box'

import { AssetsContext } from '../../context'
import { Formik, Form as FormikForm } from 'formik'
import { Observer } from '@components/HOCs/Observer'
import { AssetFields } from './AssetFields'
import { handleInterestRateControlChanges } from './interestRateControl'
import { buildInitialValues } from './formService'
import { setupValidations } from './validations'
import { Button } from '@components/Button'
import { Aside } from './Aside'

export const ASIDE_VIEWS = {
  DEFAULT_UNIT_TRUST_EXPLANATION: "DEFAULT_UNIT_TRUST_EXPLANATION",
  DEFAULT_LIVING_ANNUITY_EXPLANATION: "DEFAULT_LIVING_ANNUITY_EXPLANATION",
  CASH_WITHDRAWAL_EXPLANATION: "CASH_WITHDRAWAL_EXPLANATION"
}

export const Form = () => {
  const { actions } = useContext(AssetsContext)
  const { submit } = actions
  const [asideView, setAsideView] = useState(false);

  return (
    <Formik
      onSubmit={async (formAsset) => await submit(formAsset)}
      enableReinitialize
      validationSchema={setupValidations()}
      initialValues={buildInitialValues()}
      render={(formProps) => (
        <FormikForm>
          <div className='app-form app-form--nested-in-card lg:grid lg:grid-cols-2'>
            <Main formProps={formProps} setAsideView={setAsideView} />
            <Aside formProps={formProps} asideView={asideView} />
          </div>
        </FormikForm>
      )}
    />
  )
}

const Main = ({ formProps, setAsideView }) => {
  const { state, actions } = useContext(AssetsContext)
  const { submitLabel, deleteLabel, loading, asset } = state
  const { deleteAsset, back } = actions
  const { isValid } = formProps

  return (
    <section>
      <Observer
        value={formProps.values}
        onChange={handleInterestRateControlChanges(formProps, state)}
      />
      <AssetFields
        values={formProps.values}
        errors={formProps.errors}
        setFieldValue={formProps.setFieldValue}
        setValues={formProps.setValues}
        setFieldTouched={formProps.setFieldTouched}
        setAsideView={setAsideView}
      />
      <Box className='grid grid-cols-2 gap-4'>
        <Button className='button button--secondary' onClick={back}>Back</Button>
        <Button className='button button--primary' type='submit' disabled={!isValid || loading}>{loading ? 'Loading...' : submitLabel}</Button>
        <Button className='button button--tertiary col-span-2' disabled={loading} onClick={deleteAsset(asset)}>
          {deleteLabel}
        </Button>
      </Box>
    </section>
  )
}
